import { render, staticRenderFns } from "./FormControlCalidad.vue?vue&type=template&id=746838ca&"
import script from "./FormControlCalidad.vue?vue&type=script&lang=js&"
export * from "./FormControlCalidad.vue?vue&type=script&lang=js&"
import style0 from "./FormControlCalidad.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports